'use client';

import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import AppAuthenticated from "../AppAuthenticated";
import Login from "../auth/Login";
import Register from "../auth/Register";
import WithData from "./WithData";

const WithAuthentication = (props: any) => {
    const { user, isLoading } = useAuth();
    const [authComponentMode, setAuthComponentMode] = useState<'login' | 'register'>('login');

    // Load auth component mode from localStorage if available
    useEffect(() => {
        const mode = window.localStorage.getItem('authComponentMode') as 'login' | 'register' | null;
        if (mode === 'register' || mode === 'login') {
            setAuthComponentMode(mode);
        }
    }, []);

    if (isLoading) {
        return null;
    }

    const renderAuthComponent = () => {
        if (authComponentMode === 'register'){
            return <Register />
        }
        else{
            return <Login />
        }
    }

    return (
        <>
        {user?.id ? <WithData /> : renderAuthComponent()}
        </>
    );
};

export default WithAuthentication;


